import InvoiceExportApp from "invoice/export/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const invoiceExportRoute: RouteObject = {
  path: "invoiceexport",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: InvoiceExportApp,
  }]
};